export default __webpack_public_path__ + "static/media/gallery-wip-handle-disc_05.a0b445d9.jpg";